import React from 'react';
import Legend from './Legend';
import DataArcSelected from './DataArcSelected';

export default function ArcSelectionFunnel({
	selectedJourneyData,
	setActiveTab,
	activeTab,
	legendData,
	tunnelData,
	totalLevel1Sessions,
	handleDeselect,
	handleArcClick
}) {

	return (
		<>
			{!selectedJourneyData ? (
				<Legend
					legendData={legendData}
					totalLevel1Sessions={totalLevel1Sessions}
					selectedJourneyData={selectedJourneyData}
					handleArcClick={handleArcClick}
				/>
			) : (
				<DataArcSelected
					tunnelData={tunnelData}
					totalLevel1Sessions={totalLevel1Sessions}
					setActiveTab={setActiveTab}
					selectedJourneyData={selectedJourneyData}
					handleArcClick={handleArcClick}
					activeTab={activeTab}
					handleDeselect={handleDeselect}
				/>
			)}
		</>
	);
}
